// booking/utils/object.js

/**
 * 稳定 stringify（防止 key 顺序变化导致 hash 抖动）
 */
export function stableStringify(obj) {
    const allKeys = [];

    JSON.stringify(obj, (k, v) => {
        allKeys.push(k);
        return v;
    });

    allKeys.sort();

    return JSON.stringify(obj, allKeys);
}